<template>
<div class="container">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'regularPage'
}
</script>

<style lang="scss" scoped>
h1{
  padding-top: 220px;
}
img{
  width: 100%;
  border-radius: 25px;
  margin: 0 auto;
  display: block;
}
  
</style>